import Platforms from '../pages/campaigns/Platforms'

export const PlatformsRoutes =  [
    {
        path: 'campaigns/platforms/:id',
        element: <Platforms />
    }
]